export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "GraphAlgorithmWorker-5bca33dce3a287a1b008.min.worker.js");
}
